import { render } from "./ReviewEdit.vue?vue&type=template&id=174217b6&scoped=true"
import script from "./ReviewEdit.vue?vue&type=script&lang=js"
export * from "./ReviewEdit.vue?vue&type=script&lang=js"

import "./ReviewEdit.vue?vue&type=style&index=0&id=174217b6&lang=scss&scoped=true"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174217b6"]])

export default __exports__